var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDomainButtonGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 280.034,
    viewBox: "0 0 500 280.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-domain-button-gd",
    transform: "translate(-710.5 -222.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset_2",
    "data-name": "Asset 2",
    transform: "translate(963.014 222.994)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 69.944,
    cy: 69.944,
    r: 69.944,
    transform: "translate(-29.137 112.22) rotate(-45)",
    fill: "#e0e0e0",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7357",
    "data-name": "Path 7357",
    d: "M110.511,17.781a10.032,10.032,0,0,0-1,10.994c.875,1.567,2.211,2.976,2.412,4.759.328,2.9-2.481,5.5-2.032,8.385.3,1.953,2.008,3.351,2.907,5.111a6.737,6.737,0,0,1-.772,7.165c-1.275,1.553-3.266,2.54-4.092,4.371-.613,1.358-.464,2.947-.958,4.353a6.773,6.773,0,0,1-5.328,4.015,19.961,19.961,0,0,1-6.944-.391l.5-2.512a4.912,4.912,0,0,1-3.989,2.237,14.5,14.5,0,0,1-4.692-.7C85.588,61.306,84.659,56.8,86,52.643c1.2-3.739,4.071-6.655,6.457-9.776a44.174,44.174,0,0,0,6.293-11.4c1.094-2.938,1.883-6.013,3.406-8.754s3.961-5.189,7.042-5.768",
    transform: "translate(-0.665 -0.099)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7358",
    "data-name": "Path 7358",
    d: "M156.163,76.748l-13.837.94-.133-3.556a7.75,7.75,0,0,1,1.194-5.03,3.094,3.094,0,0,0,.327-.848c.1-1.055-1.457-6.343-2.02-8.281-.676-2.325.646-3.557,1.158-2.608.939,1.74,3.412,9.21,4.19,9.893s.33-3.17.33-3.17c-1.216-8.22-1.741-9.416-.277-9.727,1.675-.357,3.527,11.881,3.527,11.881s-.249-1.711,1.061-2.059,1.917,1.341,1.917,1.341c-.163-.872,1.08-1.011,1.08-1.011,3.1.427,1.484,12.235,1.484,12.235l-13.837.94L135.7,123.967l-7.083-10.842L110.148,126.3l16.653,19.86a14.756,14.756,0,0,0,11.857,5.265h0a14.756,14.756,0,0,0,14.184-13.94Z",
    transform: "translate(-0.81 -0.316)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7359",
    "data-name": "Path 7359",
    d: "M145.505,76.954c-.056-.063.676-.714,1.658-1.93a18.753,18.753,0,0,0,1.558-2.247c.262-.443.518-.918.756-1.424a3.326,3.326,0,0,0,.473-1.518.641.641,0,0,0-.4-.571,1.207,1.207,0,0,0-.789.131,8.251,8.251,0,0,0-1.543.924,8.634,8.634,0,0,0-1.968,2.109l-.156.237-.121-.247a5.219,5.219,0,0,0-1.115-1.4c0-.038.759.175,1.4,1.253l-.277-.01a7.966,7.966,0,0,1,1.953-2.309,8.158,8.158,0,0,1,1.623-1.019,1.658,1.658,0,0,1,1.146-.163,1.15,1.15,0,0,1,.765,1,3.58,3.58,0,0,1-.53,1.8,16.036,16.036,0,0,1-2.492,3.688A7.312,7.312,0,0,1,145.505,76.954Z",
    transform: "translate(-1.006 -0.4)",
    fill: "#d1734a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7360",
    "data-name": "Path 7360",
    d: "M151.023,67.11a12.523,12.523,0,0,1-.007,2.546l-.15,2.742a10.012,10.012,0,0,0-.041,1.576c.034.48.462.9.813.7.373-.2.55-.8.7-1.321s.273-1.06.381-1.563c.215-1.006.376-1.925.521-2.695a10.839,10.839,0,0,1,.591-2.476,14.532,14.532,0,0,1-.229,2.532c-.1.778-.222,1.706-.415,2.733-.1.513-.211,1.051-.36,1.6a2.481,2.481,0,0,1-.954,1.649.973.973,0,0,1-1.107-.182,1.466,1.466,0,0,1-.44-.915,9.211,9.211,0,0,1,.067-1.668c.094-.987.182-1.907.262-2.75A12.335,12.335,0,0,1,151.023,67.11Z",
    transform: "translate(-1.043 -0.387)",
    fill: "#d1734a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7361",
    "data-name": "Path 7361",
    d: "M153.364,70.608c.08.025-.123.58-.06,1.472a2.758,2.758,0,0,0,.43,1.4c.169.165.282.171.449-.02a5.9,5.9,0,0,0,.451-.855,30.451,30.451,0,0,0,1.488-4.847,9.236,9.236,0,0,1-1.018,5.064,5.271,5.271,0,0,1-.531.963.8.8,0,0,1-.613.312.785.785,0,0,1-.585-.3,1.945,1.945,0,0,1-.37-.9,3.914,3.914,0,0,1-.066-.8C152.971,71.106,153.315,70.58,153.364,70.608Z",
    transform: "translate(-1.059 -0.394)",
    fill: "#d1734a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7362",
    "data-name": "Path 7362",
    d: "M94.239,157.6l1.3,20.125c-39.361,15.086-68.564-9.937-68.564-9.937l5.889-18,1.033-31.442-7.6,8.428L22.73,123.8,4.687,108.751l-3.87-3.227L19.539,85.761C43.2,60.283,61.626,68.1,61.626,68.1l27.686,2.59s19.146,2.711,28.41,19.495c7.543,13.665,15.757,28.132,15.757,28.132l-23.722,16.93-7.54-13.865Z",
    transform: "translate(-0.174 -0.39)",
    fill: "#6954bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7363",
    "data-name": "Path 7363",
    d: "M0,112.587c-.016,1.177.03,2.356.074,3.547A69.782,69.782,0,0,0,1.963,129.98l.034.132c.138.563.3,1.116.453,1.674.619,2.188,1.429,4.119,2.212,6.239.1.264.2.531.3.793,2.506-.657,9.163-6.948,17.287-15.176L4.22,108.608C1.872,111.134.784,112.283,0,112.587Z",
    transform: "translate(-0.169 -0.632)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7364",
    "data-name": "Path 7364",
    d: "M87.151,72.927c.967-6.857,2.111-14.057,2.111-14.057s9.039-.249,12.46-11.526c3.262-10.755,4.952-36.4,4.952-36.4h0a33.448,33.448,0,0,0-38.02,3.363h0L61.718,70.13c-.805,6.48,4.125,12.333,11.07,13.143h0C79.8,84.09,86.229,79.46,87.151,72.927Z",
    transform: "translate(-0.528 -0.038)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7365",
    "data-name": "Path 7365",
    d: "M100.879,30.46a1.493,1.493,0,0,1-1.632,1.3,1.428,1.428,0,0,1-1.34-1.543,1.493,1.493,0,0,1,1.63-1.3,1.429,1.429,0,0,1,1.342,1.544Z",
    transform: "translate(-0.739 -0.168)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7366",
    "data-name": "Path 7366",
    d: "M103.5,29.125c-.21.168-1.216-.816-2.808-1.031-1.587-.238-2.867.42-3.013.2-.073-.1.162-.42.721-.72a4.1,4.1,0,0,1,2.445-.4,3.933,3.933,0,0,1,2.2,1.062C103.488,28.679,103.605,29.051,103.5,29.125Z",
    transform: "translate(-0.737 -0.158)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7367",
    "data-name": "Path 7367",
    d: "M84.456,28.483a1.493,1.493,0,0,1-1.632,1.3,1.428,1.428,0,0,1-1.34-1.543,1.493,1.493,0,0,1,1.63-1.3,1.429,1.429,0,0,1,1.342,1.544Z",
    transform: "translate(-0.643 -0.157)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7368",
    "data-name": "Path 7368",
    d: "M86.724,27.4c-.21.168-1.217-.816-2.808-1.031-1.587-.238-2.867.42-3.013.2-.073-.1.16-.42.722-.72a4.1,4.1,0,0,1,2.445-.4,3.936,3.936,0,0,1,2.2,1.062C86.707,26.958,86.826,27.329,86.724,27.4Z",
    transform: "translate(-0.64 -0.148)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M90.929,40.007a10.637,10.637,0,0,1,2.649-.11c.412.014.808-.014.914-.281a2.089,2.089,0,0,0-.105-1.242l-.775-3.26c-1.061-4.635-1.769-8.424-1.582-8.465s1.2,3.682,2.26,8.318q.377,1.712.722,3.271A2.373,2.373,0,0,1,95,39.862a1.029,1.029,0,0,1-.75.5,2.79,2.79,0,0,1-.7,0,10.45,10.45,0,0,1-2.62-.358Z",
    transform: "translate(-0.698 -0.155)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    d: "M89.336,59.139a29.609,29.609,0,0,1-14.873-6.248s2.654,8.437,14.342,8.949Z",
    transform: "translate(-0.602 -0.308)",
    fill: "#d1734a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7371",
    "data-name": "Path 7371",
    d: "M94.586,7.351c.744,1.82-.426,3.96-2.09,5.008a14.546,14.546,0,0,1-5.632,1.595,10.23,10.23,0,0,0-5.433,2.062c-2.7,2.45-2.016,5.992-4.725,9.155a5.871,5.871,0,0,1-5.729,2.4c-2.189-.312-5.021.2-6.131,2.719C63.788,32.7,65.076,34.68,66.3,37s.9,4.689.2,7.222c-.5,1.834-2.07,3.265-2.424,5.133-.557,2.942,1.993,6.3.269,8.748s-6.051,1.333-8.005,3.606c-.7.808-1.084,2.032-2.114,2.306a2.94,2.94,0,0,1-1.847-.337L43.4,59.893l.708-2.784a6.009,6.009,0,0,1-9.582-1.454,26.864,26.864,0,0,0,5.166-3.9A9.036,9.036,0,0,0,42.4,46.012c.1-2.617-1.328-5.273-.531-7.768,1.141-3.57,5.936-4.469,8.092-7.534,2.013-2.862,1.316-7.017,3.375-9.845,2.394-3.287,7.462-3.438,10.2-6.44,1.859-2.035,2.285-4.979,3.64-7.379a13.559,13.559,0,0,1,7.685-5.89A29.528,29.528,0,0,1,84.655.01a15.211,15.211,0,0,1,7.193,1.444c2.159,1.2,3.793,3.675,3.287,6.093",
    transform: "translate(-0.37 0)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7372",
    "data-name": "Path 7372",
    d: "M71.147,27.733a6.94,6.94,0,0,0-3.744-.274,4.842,4.842,0,0,0-3.056,2.09,5.063,5.063,0,0,0-.54,3.681,8.569,8.569,0,0,0,1.673,3.39,5.808,5.808,0,0,0,2.033,1.794,2.773,2.773,0,0,0,2.623-.044",
    transform: "translate(-0.54 -0.159)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7373",
    "data-name": "Path 7373",
    d: "M69.45,35.124c.135.065-.5.737-1.59.278a2.449,2.449,0,0,1-1.225-1.408,5.536,5.536,0,0,1-.332-2.131,3.251,3.251,0,0,1,.821-2.1,2.164,2.164,0,0,1,1.752-.733c1.163.134,1.412.987,1.277.992-.106.081-.5-.4-1.283-.317a2.1,2.1,0,0,0-1.613,2.2c-.037,1.288.29,2.516.926,2.9C68.835,35.263,69.386,35.011,69.45,35.124Z",
    transform: "translate(-0.555 -0.169)",
    fill: "#d1734a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7374",
    "data-name": "Path 7374",
    d: "M94.969,7.995a5.759,5.759,0,0,0,2.391,6.863c1.29.747,2.882.981,3.987,1.983a6.32,6.32,0,0,1,1.665,4.029,14.745,14.745,0,0,0,.826,4.359,3.481,3.481,0,0,0,3.474,2.246l2.489-7.362c.917-2.714,1.846-5.6,1.191-8.391-.936-3.983-4.871-6.585-8.816-7.671a8.12,8.12,0,0,0-5.559.052c-1.714.8-2.876,2.992-2,4.672",
    transform: "translate(-0.718 -0.021)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7375",
    "data-name": "Path 7375",
    d: "M46.7,61.116A7.692,7.692,0,0,0,47.3,60.5a4.492,4.492,0,0,0,.808-2.273,21.665,21.665,0,0,0-.217-3.9,6.47,6.47,0,0,1,.238-2.482,6.543,6.543,0,0,1,1.4-2.425c1.3-1.486,3.124-2.631,4.7-4.214a6.848,6.848,0,0,0,1.792-2.855,8.219,8.219,0,0,0,.1-3.593c-.187-1.246-.5-2.519-.664-3.867a8.682,8.682,0,0,1,6.762-9.739c2.921-.647,5.924-.253,8.354-1.482a5.873,5.873,0,0,0,2.611-2.829,25.415,25.415,0,0,0,1.264-3.663,13.633,13.633,0,0,1,1.467-3.484,6,6,0,0,1,2.755-2.3,14.511,14.511,0,0,1,6.309-.671,16.513,16.513,0,0,0,5.125-.295A7.5,7.5,0,0,0,93.473,8.64a4.2,4.2,0,0,0,1-2.185c.1-.555.1-.856.127-.855a3.88,3.88,0,0,1-.024.87,4.157,4.157,0,0,1-.949,2.3,7.573,7.573,0,0,1-3.446,1.932,16.508,16.508,0,0,1-5.218.382,14.294,14.294,0,0,0-6.125.7,5.562,5.562,0,0,0-2.542,2.154A13.279,13.279,0,0,0,74.9,17.313a25.545,25.545,0,0,1-1.274,3.739,7.4,7.4,0,0,1-1.13,1.753A6.261,6.261,0,0,1,70.8,24.118c-2.639,1.321-5.675.9-8.474,1.537a8.194,8.194,0,0,0-6.384,9.178c.148,1.305.459,2.577.644,3.854a8.644,8.644,0,0,1-.134,3.793,7.265,7.265,0,0,1-1.922,3.026c-1.643,1.619-3.463,2.736-4.731,4.156a5.975,5.975,0,0,0-1.626,4.648,20.6,20.6,0,0,1,.128,3.939,4.424,4.424,0,0,1-.927,2.314,2.18,2.18,0,0,1-.674.553Z",
    transform: "translate(-0.441 -0.033)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7376",
    "data-name": "Path 7376",
    d: "M100.271,66.9a5.521,5.521,0,0,0,.468-.527,3.687,3.687,0,0,0,.6-1.889c.082-.873-.148-1.945-.089-3.239A7.453,7.453,0,0,1,103,57.3c.918-1.28,2.149-2.617,2.478-4.4s-.438-3.707-.813-5.8a6.977,6.977,0,0,1,.135-3.306,11.886,11.886,0,0,1,1.557-3.054c.637-.963,1.337-1.886,1.888-2.906a7.064,7.064,0,0,0,1-3.282,5.96,5.96,0,0,0-1.1-3.217A13.289,13.289,0,0,1,106.5,28.2c-.684-2.319-.155-4.586-.014-6.644a11.686,11.686,0,0,0-.064-3,5.751,5.751,0,0,0-1.1-2.538,12.265,12.265,0,0,0-4.054-3.051,22.748,22.748,0,0,1-3.693-2.224,8.176,8.176,0,0,1-2.166-2.444,4.428,4.428,0,0,1-.586-1.977,2.625,2.625,0,0,1,.046-.717c.028,0,.005.249.058.708A4.612,4.612,0,0,0,95.591,8.2a8.191,8.191,0,0,0,2.168,2.315,23.337,23.337,0,0,0,3.687,2.13,12.481,12.481,0,0,1,4.223,3.113,6.175,6.175,0,0,1,1.2,2.716,12.05,12.05,0,0,1,.092,3.122c-.14,2.094-.624,4.324.023,6.458a12.954,12.954,0,0,0,1.593,3.02,6.45,6.45,0,0,1,1.181,3.488,7.544,7.544,0,0,1-1.062,3.525c-.577,1.061-1.291,2-1.917,2.94a11.476,11.476,0,0,0-1.506,2.917,6.507,6.507,0,0,0-.137,3.084c.339,2.016,1.14,3.991.765,5.953a6.779,6.779,0,0,1-1.11,2.536c-.488.735-1.02,1.381-1.5,2.011a7.22,7.22,0,0,0-1.76,3.748c-.086,1.231.115,2.331,0,3.235a3.622,3.622,0,0,1-.715,1.934A1.514,1.514,0,0,1,100.271,66.9Z",
    transform: "translate(-0.721 -0.033)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7377",
    "data-name": "Path 7377",
    d: "M36.5,56.445c.006-.03.325.056.943.078a6.349,6.349,0,0,0,2.623-.509,7.641,7.641,0,0,0,3.264-2.623,10.664,10.664,0,0,0,1.778-5.269c.237-2.092-.284-4.362-.345-6.889a7.341,7.341,0,0,1,.846-3.837,9.189,9.189,0,0,1,3.134-2.724,6.746,6.746,0,0,0,2.889-2.886,13.164,13.164,0,0,0,.636-4.324,13.141,13.141,0,0,1,.892-4.623A6.648,6.648,0,0,1,54.5,20.774a4.448,4.448,0,0,1,2.28-1.062c1.652-.286,3.259-.114,4.792-.282a6.364,6.364,0,0,0,4.007-1.788,13.118,13.118,0,0,0,2.51-3.585c.668-1.29,1.183-2.625,1.815-3.893a15.986,15.986,0,0,1,2.238-3.481,7.178,7.178,0,0,1,3.244-2.213,6.744,6.744,0,0,1,3.667,0,19.71,19.71,0,0,1,3.137,1.178,15.117,15.117,0,0,0,5.358,1.695,10.572,10.572,0,0,0,4.183-.64,12.108,12.108,0,0,0,3.171-1.784,4.6,4.6,0,0,1-.71.637,9.844,9.844,0,0,1-2.39,1.335,10.57,10.57,0,0,1-4.269.74,15.2,15.2,0,0,1-5.491-1.648A19.584,19.584,0,0,0,78.96,4.858a6.348,6.348,0,0,0-3.444.021,6.756,6.756,0,0,0-3.029,2.1,15.615,15.615,0,0,0-2.152,3.392c-1.2,2.47-2.135,5.41-4.4,7.635a7.094,7.094,0,0,1-1.962,1.344,7.408,7.408,0,0,1-2.34.588c-1.6.173-3.211.007-4.751.279a3.936,3.936,0,0,0-2.023.932,6.2,6.2,0,0,0-1.225,1.891,12.692,12.692,0,0,0-.858,4.446,13.486,13.486,0,0,1-.688,4.492A7.19,7.19,0,0,1,49,35.073a8.811,8.811,0,0,0-3,2.561,6.948,6.948,0,0,0-.8,3.6c.037,2.445.545,4.778.281,6.924a10.886,10.886,0,0,1-1.907,5.4A7.757,7.757,0,0,1,40.139,56.2a6.139,6.139,0,0,1-2.7.426,3.618,3.618,0,0,1-.938-.183Z",
    transform: "translate(-0.382 -0.025)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7378",
    "data-name": "Path 7378",
    d: "M109.9,18.56a7.331,7.331,0,0,0-.823-2.864,8.483,8.483,0,0,0-2.112-2.43,17.113,17.113,0,0,0-3.457-2.011c-1.3-.6-2.578-1.142-3.687-1.758a12.545,12.545,0,0,1-2.731-1.974A7.092,7.092,0,0,1,95.722,5.7a1.961,1.961,0,0,1-.28-.785,11.494,11.494,0,0,0,1.9,2.338,13.542,13.542,0,0,0,2.707,1.821c1.092.578,2.362,1.1,3.679,1.709a16.178,16.178,0,0,1,3.54,2.111,8.316,8.316,0,0,1,2.134,2.629,5.415,5.415,0,0,1,.593,2.2,1.831,1.831,0,0,1-.094.83Z",
    transform: "translate(-0.724 -0.029)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7379",
    "data-name": "Path 7379",
    d: "M87.327,23.429c-.1.114-.449-.039-1.011-.17a10.085,10.085,0,0,0-4.49-.017c-.563.127-.911.277-1.012.162-.092-.095.135-.493.734-.84a5.516,5.516,0,0,1,5.052.02C87.2,22.935,87.42,23.335,87.327,23.429Z",
    transform: "translate(-0.639 -0.128)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7380",
    "data-name": "Path 7380",
    d: "M101.936,25.4c-.041.283-1.081.366-2.324.186s-2.216-.556-2.175-.839,1.081-.366,2.324-.186S101.976,25.116,101.936,25.4Z",
    transform: "translate(-0.736 -0.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7381",
    "data-name": "Path 7381",
    d: "M66.914,38.153c.014-.011.1.075.244.251a4.1,4.1,0,0,1,.534.851,6.09,6.09,0,0,1,.44,3.644,17.647,17.647,0,0,1-1.778,5.136,4.628,4.628,0,0,0-.44,2.948,13.824,13.824,0,0,0,1.4,3.045,5.376,5.376,0,0,1-.638,6.429,4.982,4.982,0,0,1-2.543,1.547,13.563,13.563,0,0,1-2.536.279,6.346,6.346,0,0,0-3.411.875,4.683,4.683,0,0,0-.926.92c-.012-.006.019-.125.134-.326A2.642,2.642,0,0,1,58.068,63a6.218,6.218,0,0,1,3.506-1.079,13.991,13.991,0,0,0,2.453-.33,4.581,4.581,0,0,0,2.294-1.447,5.206,5.206,0,0,0,1.234-2.736,5.112,5.112,0,0,0-.7-3.142,13.757,13.757,0,0,1-1.435-3.171,5.071,5.071,0,0,1,.5-3.249c.429-.944.894-1.772,1.181-2.618a13.968,13.968,0,0,0,.672-2.385,6.19,6.19,0,0,0-.263-3.505C67.184,38.556,66.872,38.183,66.914,38.153Z",
    transform: "translate(-0.502 -0.222)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7382",
    "data-name": "Path 7382",
    d: "M113.383,64.724a1.354,1.354,0,0,1-.636.119,2.379,2.379,0,0,1-1.646-.833,3.254,3.254,0,0,1-.815-2.791,6.9,6.9,0,0,1,1.929-3.368,18.991,18.991,0,0,0,2.983-3.49,4.527,4.527,0,0,0,.56-2.384,7.771,7.771,0,0,0-.617-2.581,54.939,54.939,0,0,1-2.379-5.433,5.8,5.8,0,0,1-.037-3.224,16.134,16.134,0,0,1,1.483-2.906,4.124,4.124,0,0,0,.639-2.9,5.447,5.447,0,0,0-1.529-2.518c-.69-.738-1.443-1.42-2.081-2.207a6.717,6.717,0,0,1-1.35-2.647,11.892,11.892,0,0,1,.075-5.4c.356-1.652.824-3.141,1.123-4.524a10.187,10.187,0,0,0-.29-6.533,7.143,7.143,0,0,0-1.4-1.991c.006-.007.052.023.139.088a3.022,3.022,0,0,1,.365.313,5.377,5.377,0,0,1,1.078,1.5,8.009,8.009,0,0,1,.762,2.829,13.117,13.117,0,0,1-.3,3.865c-.28,1.407-.73,2.907-1.06,4.535a11.56,11.56,0,0,0-.034,5.2,6.247,6.247,0,0,0,1.272,2.456c.609.744,1.355,1.417,2.068,2.172a5.911,5.911,0,0,1,1.664,2.76,4.627,4.627,0,0,1-.69,3.25,16.036,16.036,0,0,0-1.445,2.809,5.308,5.308,0,0,0,.034,2.939,57.863,57.863,0,0,0,2.333,5.389,8.181,8.181,0,0,1,.629,2.746,4.959,4.959,0,0,1-.638,2.6,18.771,18.771,0,0,1-3.093,3.534,6.673,6.673,0,0,0-1.912,3.172,3.053,3.053,0,0,0,.682,2.6,2.337,2.337,0,0,0,1.5.862C113.161,64.772,113.376,64.693,113.383,64.724Z",
    transform: "translate(-0.805 -0.053)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383",
    "data-name": "Path 7383",
    d: "M152.62,78.534a17.914,17.914,0,0,0-2.157-2.326,17.931,17.931,0,0,0-2.8-1.491,5.206,5.206,0,0,1,4.958,3.816Z",
    transform: "translate(-1.028 -0.435)",
    fill: "#d1734a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384",
    "data-name": "Path 7384",
    d: "M137.73,133.306a14.663,14.663,0,0,1-1.442-4.513,14.662,14.662,0,0,1-.432-4.718,42.383,42.383,0,0,1,.939,4.615,42.4,42.4,0,0,1,.935,4.616Z",
    transform: "translate(-0.959 -0.721)",
    fill: "#d1734a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385",
    "data-name": "Path 7385",
    d: "M73.85,122.04a9.43,9.43,0,0,0,6.4-8.13c.534-5.18-2.935-9.783-7.749-10.282s-9.147,3.3-9.681,8.475a9.416,9.416,0,0,0,4.689,9.31c-7.449.389-11.063,4.982-12.822,9.066a19.812,19.812,0,0,0,11.447,7.777l5.37.557A19.809,19.809,0,0,0,84.442,133.4C83.546,129.032,80.956,123.853,73.85,122.04Z",
    transform: "translate(-0.487 -0.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16801",
    "data-name": "Group 16801",
    transform: "translate(26.797 113.4)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7386",
    "data-name": "Path 7386",
    d: "M34.047,118.615l4.413-4.552s-1.906,32.913-3.207,36.869-8.128,17.129-8.128,17.129l5.889-18Z",
    transform: "translate(-27.124 -114.064)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7387",
    "data-name": "Path 7387",
    d: "M43.813,108.454c.1.1-3.781,4.308-8.674,9.4s-8.945,9.141-9.048,9.041,3.78-4.307,8.675-9.4S43.71,108.356,43.813,108.454Z",
    transform: "translate(-0.321 -0.631)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7388",
    "data-name": "Path 7388",
    d: "M105.951,105.863a3.989,3.989,0,0,1-.043,1.034c-.06.661-.172,1.615-.332,2.791-.318,2.352-.849,5.59-1.587,9.136s-1.547,6.728-2.194,9.011c-.323,1.142-.6,2.061-.81,2.691a3.987,3.987,0,0,1-.374.965,4,4,0,0,1,.179-1.019l.65-2.73c.556-2.3,1.3-5.487,2.041-9.024s1.322-6.754,1.732-9.087l.494-2.763A4,4,0,0,1,105.951,105.863Z",
    transform: "translate(-0.754 -0.616)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7389",
    "data-name": "Path 7389",
    d: "M85.854,42.771a2.119,2.119,0,1,1-.569,2.432,2.235,2.235,0,0,1,1.3-2.889",
    transform: "translate(-0.664 -0.246)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7390",
    "data-name": "Path 7390",
    d: "M86.064,40.542c.261.021.026,1.748,1.335,3.178s3.174,1.493,3.154,1.737c.009.112-.456.279-1.236.193A4.341,4.341,0,0,1,86.671,44.3a3.78,3.78,0,0,1-1.009-2.649C85.7,40.917,85.948,40.516,86.064,40.542Z",
    transform: "translate(-0.667 -0.236)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7391",
    "data-name": "Path 7391",
    d: "M63.826,14.588a9.984,9.984,0,0,0,2.121-4.9,5.281,5.281,0,0,0-4.6-5.256,5.583,5.583,0,0,0-5.763,4.079,5.925,5.925,0,0,0,2.954,6.492,6.313,6.313,0,0,0,7.119-1.091",
    transform: "translate(-0.492 -0.026)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7392",
    "data-name": "Path 7392",
    d: "M66.145,9.459A5.205,5.205,0,0,1,65.12,13.1,5.2,5.2,0,0,1,62.2,15.507a18.456,18.456,0,0,0,2.485-2.69A18.446,18.446,0,0,0,66.145,9.459Z",
    transform: "translate(-0.531 -0.055)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7393",
    "data-name": "Path 7393",
    d: "M63.064,14.966a19.967,19.967,0,0,0-.649-5.532A19.965,19.965,0,0,0,59.8,4.515c.042-.043.559.35,1.216,1.164A11.262,11.262,0,0,1,63.4,13.317a3.9,3.9,0,0,1-.337,1.649Z",
    transform: "translate(-0.517 -0.026)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16802",
    "data-name": "Group 16802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset_1",
    "data-name": "Asset 1",
    transform: "translate(820 309.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7394",
    "data-name": "Path 7394",
    d: "M89.916,0H335.549a4.369,4.369,0,0,1,4.369,4.369V177.2a4.369,4.369,0,0,1-4.369,4.369H89.916a4.369,4.369,0,0,1-4.369-4.369V4.369A4.369,4.369,0,0,1,89.916,0Z",
    transform: "translate(-72.619 0)",
    fill: "#d3dfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 238.918,
    height: 144.837,
    transform: "translate(20.654 14.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7395",
    "data-name": "Path 7395",
    d: "M374,238.838H134.4V93.314H374Zm-238.918-.687h238.23V94H135.085Z",
    transform: "translate(-114.088 -79.212)",
    fill: "#86a7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 238.918,
    height: 9.006,
    transform: "translate(20.654 5.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7396",
    "data-name": "Path 7396",
    d: "M374,43.411H134.4V33.718H374Zm-238.917-.687h238.23V34.405H135.085Z",
    transform: "translate(-114.088 -28.623)",
    fill: "#86a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7397",
    "data-name": "Path 7397",
    d: "M199.3,56.182A2.081,2.081,0,1,1,201.38,54.1,2.081,2.081,0,0,1,199.3,56.182Zm0-3.475a1.394,1.394,0,1,0,1.394,1.394A1.394,1.394,0,0,0,199.3,52.707Z",
    transform: "translate(-167.414 -44.159)",
    fill: "#86a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7398",
    "data-name": "Path 7398",
    d: "M245.278,56.182a2.081,2.081,0,1,1,2.081-2.081A2.081,2.081,0,0,1,245.278,56.182Zm0-3.475a1.394,1.394,0,1,0,1.394,1.394A1.394,1.394,0,0,0,245.278,52.707Z",
    transform: "translate(-206.445 -44.159)",
    fill: "#86a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7399",
    "data-name": "Path 7399",
    d: "M291.26,56.182a2.081,2.081,0,1,1,2.081-2.081A2.081,2.081,0,0,1,291.26,56.182Zm0-3.475a1.394,1.394,0,1,0,1.394,1.394,1.394,1.394,0,0,0-1.394-1.394Z",
    transform: "translate(-245.478 -44.159)",
    fill: "#86a7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 279.453,
    height: 12.96,
    transform: "translate(0.386 178.844)",
    fill: "#d3dfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7400",
    "data-name": "Path 7400",
    d: "M280.226,1194.619H0v-13.731H280.226ZM.771,1193.847H279.455v-12.188H.771Z",
    transform: "translate(0 -1002.43)",
    fill: "#86a7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 30.19,
    height: 7.25,
    rx: 3.625,
    transform: "translate(125.018 165.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7401",
    "data-name": "Path 7401",
    d: "M852.352,1100.395H828.505a3.52,3.52,0,0,1-3.516-3.516v-.906a3.52,3.52,0,0,1,3.516-3.516h23.846a3.52,3.52,0,0,1,3.516,3.516v.906A3.52,3.52,0,0,1,852.352,1100.395Zm-23.846-7.25a2.832,2.832,0,0,0-2.829,2.829v.906a2.832,2.832,0,0,0,2.829,2.829h23.846a2.832,2.832,0,0,0,2.829-2.829v-.906a2.832,2.832,0,0,0-2.829-2.829Z",
    transform: "translate(-700.315 -927.363)",
    fill: "#86a7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Asset_1-2",
    "data-name": "Asset 1",
    transform: "translate(925 363.579)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 35.275,
    cy: 35.275,
    r: 35.275,
    transform: "translate(0 0)",
    fill: "#6954bf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 30.624,
    cy: 30.624,
    r: 30.624,
    transform: "translate(4.652 4.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7402",
    "data-name": "Path 7402",
    d: "M275.542,262.585h-9.879v-9.879H258.55v9.879h-9.879V269.7h9.879v9.879h7.113V269.7h9.879Z",
    transform: "translate(-227.586 -231.279)",
    fill: "#6954bf"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 500,
    transform: "translate(710.5 502.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDomainButtonGd);
export default __webpack_public_path__ + "static/media/add-domain-button-gd.bd983652aa86f5fa6e811a6e99d06385.svg";
export { ForwardRef as ReactComponent };